// extracted by mini-css-extract-plugin
export default {"opaque":"_-web-client-js-react-components-___WTFPrincipalListField-module__opaque___gawbB"};